class StorageManager {
  static read = prop => {
    if (window.Storage) {
      return localStorage[prop];
    }
    return null;
  };

  static save = (prop, val) => {
    if (window.Storage) {
      localStorage[prop] = val;
    }
  };
}

export default StorageManager;
